import React, { Suspense } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
//Components
import Loading from '@components/Loading';
import NotFound from '@components/ErrorsPage';
import Footer from '@components/Footer';
//Routes
import LandingPage from '@routes/Landing';
import NewGroupPage from '@routes/NewGroup';
import Embeds from '@routes/embeds';

const BasePage = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route exact path="/new-group" component={NewGroupPage} />
        <Redirect exact from="/" to="/" />
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default function Routes() {
  return (
    <Switch>
      <Route path="/embed" component={Embeds} />
      <Route path="/not-found" component={NotFound} />
      <BasePage />
      <Redirect to="/not-found" />
    </Switch>
  );
}
